import { useState, useRef, useCallback, useEffect } from 'react';

interface Tab {
  label: string;
  value: string;
  icon?: JSX.Element;
}

interface IndicatorStyle {
  left: number;
  width: number;
  height: number;
}

export const usePillTabsIndicator = (tabs: Tab[], currentTab: string) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [indicatorStyle, setIndicatorStyle] = useState<IndicatorStyle>({
    left: 0,
    width: 0,
    height: 0
  });

  const updateIndicator = useCallback(() => {
    const activeIndex = tabs.findIndex(tab => tab.value === currentTab);
    const activeTab = tabRefs.current[activeIndex];
    const container = containerRef.current;

    if (activeTab && container) {
      const containerRect = container.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();

      setIndicatorStyle({
        left: tabRect.left - containerRect.left,
        width: tabRect.width,
        height: tabRect.height
      });
    }
  }, [currentTab, tabs]);

  useEffect(() => {
    updateIndicator();
    window.addEventListener('resize', updateIndicator);
    return () => window.removeEventListener('resize', updateIndicator);
  }, [updateIndicator]);

  return {
    containerRef,
    tabRefs,
    indicatorStyle
  };
};
